import React from "react";

import styles from "./dashboardcardrow.module.scss";

interface IProps {
}

const DashboardCardRow: React.FC<IProps> = (props) => {
  return (
    <div className={styles.cardRow}>
      {props.children}
    </div>
  );
};

export default DashboardCardRow;